import script from "./TabsWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsWrapper.vue?vue&type=script&setup=true&lang=js"

import "./TabsWrapper.vue?vue&type=style&index=0&id=f87ec27e&lang=css"

const __exports__ = script;

export default __exports__